import { useState } from "react";
import type { ViewType } from "../App";

interface MobileNavProps {
  view: ViewType;
  setView: (view: ViewType) => void;
  onLogout: () => void;
}

export function MobileNav({ view, setView, onLogout }: MobileNavProps) {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      {/* More menu overlay */}
      {showMore && (
        <div className="fixed inset-0 z-40 md:hidden" onClick={() => setShowMore(false)}>
          <div className="absolute bottom-16 right-2 bg-card border border-border rounded-xl shadow-xl p-1 min-w-[160px]" onClick={(e) => e.stopPropagation()}>
            <MoreMenuItem label="Integrations" active={view === "integrations"} onClick={() => { setView("integrations"); setShowMore(false); }} />
            <MoreMenuItem label="Admin" active={view === "admin"} onClick={() => { setView("admin"); setShowMore(false); }} />
            <MoreMenuItem label="Models" active={view === "models"} onClick={() => { setView("models"); setShowMore(false); }} />
            <MoreMenuItem label="Settings" active={view === "settings"} onClick={() => { setView("settings"); setShowMore(false); }} />
            <div className="border-t border-border my-1" />
            <button onClick={onLogout} className="w-full text-left px-3 py-2 text-sm text-destructive rounded-lg hover:bg-destructive/10">
              Sign out
            </button>
          </div>
        </div>
      )}

      <nav className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-sidebar border-t border-sidebar-border">
        <div className="flex items-center justify-around h-16 px-2">
          <NavButton
            icon={<ChatIcon className="w-6 h-6" />}
            label="Chat"
            active={view === "chat"}
            onClick={() => setView("chat")}
          />
          <NavButton
            icon={<TasksIcon className="w-6 h-6" />}
            label="Tasks"
            active={view === "tasks"}
            onClick={() => setView("tasks")}
          />
          <NavButton
            icon={<MoreIcon className="w-6 h-6" />}
            label="More"
            active={showMore}
            onClick={() => setShowMore(!showMore)}
          />
        </div>
      </nav>
    </>
  );
}

function MoreMenuItem({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-3 py-2 text-sm rounded-lg transition-colors ${active ? "text-primary bg-primary/10" : "text-foreground hover:bg-card"}`}
    >
      {label}
    </button>
  );
}

function NavButton({
  icon,
  label,
  active,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`
        flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-lg
        transition-colors
        ${active ? "text-primary" : "text-muted-foreground hover:text-foreground"}
      `}
    >
      {icon}
      <span className="text-xs">{label}</span>
    </button>
  );
}

// Icons
function ChatIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
  );
}

function TasksIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
    </svg>
  );
}

function MoreIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
      <circle cx="5" cy="12" r="1" />
    </svg>
  );
}
